<template>
  <div>
    <!-- Button to trigger the modal -->
    <b-button @click="openInvoiceDocument" variant="success"> عرض الفاتورة </b-button>

    <!-- PDF Viewer Modal -->
    <b-modal v-model="showModal" centered size="xl" title="عرض الفاتورة" @hide="cleanupPdfUrl">
      <div v-if="loading" class="text-center my-4">
        <b-spinner variant="primary"></b-spinner>
        <p>جاري تحميل الفاتورة...</p>
      </div>

      <iframe v-if="pdfUrl && !loading" :src="pdfUrl" width="100%" height="700px" style="border: none"></iframe>

      <div v-if="error" class="alert alert-danger mt-3">فشل تحميل الفاتورة: {{ error }}</div>

      <!-- Delete button in modal footer -->
      <template #modal-footer="{ cancel }">
        <b-button variant="danger" @click="deleteAttachment" :disabled="loading"> حذف المرفق </b-button>
        <b-button variant="secondary" @click="cancel"> إغلاق </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal, BSpinner } from 'bootstrap-vue'
import api from '../../services/api'

export default {
  name: 'InvoicePdfViewer',
  components: {
    BButton,
    BModal,
    BSpinner
  },
  props: {
    getApiUrl: {
      type: String,
      required: false
    },
    deleteApiUrl: {
      type: String,
      required: false
    }
  },
  emits: ['delete-success'],
  data() {
    return {
      showModal: false,
      pdfUrl: null,
      loading: false,
      error: null,
      hasAttachment: false
    }
  },
  methods: {
    async openInvoiceDocument() {
      this.showModal = true
      this.loading = true
      this.error = null

      try {
        const response = await api.get(`${this.getApiUrl}`, { responseType: 'blob' })

        // Clean up previous URL if exists
        this.cleanupPdfUrl()

        // Create new blob URL
        const file = new Blob([response.data], { type: 'application/pdf' })
        this.pdfUrl = URL.createObjectURL(file)
        this.hasAttachment = true
      } catch (error) {
        console.error('Error loading invoice PDF:', error)
        this.error = 'حدث خطأ أثناء تحميل الفاتورة'
        this.hasAttachment = false

        if (error.response && error.response.status === 404) {
          this.error = 'لا يوجد مرفق للفاتورة'
        }

        this.$bvToast.toast('فشل تحميل الفاتورة', {
          title: 'خطأ',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.loading = false
      }
    },

    async deleteAttachment() {
      if (!confirm('هل أنت متأكد من حذف مرفق الفاتورة؟')) return

      try {
        this.loading = true
        await api.delete(`${this.deleteApiUrl}`)

        // Clean up and close
        this.cleanupPdfUrl()
        this.showModal = false
        this.hasAttachment = false

        this.$bvToast.toast('تم حذف مرفق الفاتورة بنجاح', {
          title: 'نجاح',
          variant: 'success',
          solid: true
        })

        // Emit event to parent component
        this.$emit('delete-success')
      } catch (error) {
        console.error('Error deleting attachment:', error)
        this.$bvToast.toast('فشل حذف مرفق الفاتورة', {
          title: 'خطأ',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.loading = false
      }
    },

    cleanupPdfUrl() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl)
        this.pdfUrl = null
      }
    }
  },
  beforeDestroy() {
    this.cleanupPdfUrl()
  }
}
</script>

<style scoped>
/* Optional styling for the modal */
::v-deep .modal-xl {
  max-width: 90%;
  margin: 1rem auto;
}

/* Style for the iframe container */
.pdf-container {
  width: 100%;
  height: 100vh;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Style for modal footer buttons */
::v-deep .modal-footer {
  justify-content: space-between;
}
</style>
